module.exports = __webpack_public_path__ + "img/document-download-outline-grey.f2a0007f.svg";